<div
  class="multi-select"
  [class.multi-select--open]="isOpen"
  [class.multi-select--disabled]="isDisabled"
  [class.multi-select--error]="hasError"
  [class.multi-select--options-overflow]="optionsOverflow"
>
  <!-- Backdrop: closes the dropdown when clicking outside -->
  @if (isOpen) {
    <div class="multi-select__backdrop" (click)="closeDropdown()"></div>
  }

  <!-- Trigger -->
  <div #inputEl class="multi-select__input" (click)="toggleDropdown()">
    @if (showSelectionCount) {
      <!-- Count-summary mode: "N Selected" + badge; chips are rendered by the parent -->
      @if (isAllOptionOnlySelection) {
        <!-- Synthetic "All …" option selected on its own: name it, no count badge -->
        <span class="multi-select__count-text">{{ allOptionLabel }}</span>
      } @else if (selectedValues.length > 0) {
        <span class="multi-select__count-text"
          >{{ selectedValues.length }} {{ selectedCountLabel }}</span
        >
        <span class="multi-select__count-badge">{{ selectedValues.length }}</span>
      } @else {
        <span class="multi-select__placeholder">{{ placeholder }}</span>
      }
    } @else {
      <!-- Selected chips -->
      @if (selectedValues.length > 0) {
        <div class="multi-select__chips-container">
          @for (chip of visibleChips; track chip.uuid) {
            <div class="multi-select__chip">
              <span class="multi-select__chip-text">{{ chip.name }}</span>
              @if (showChipRemove) {
                <button
                  class="multi-select__chip-remove"
                  type="button"
                  (click)="removeChip(chip.uuid, $event)"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              }
            </div>
          }
          @if (hiddenChipCount > 0) {
            <div class="multi-select__chip multi-select__chip--more">
              <span class="multi-select__chip-text">+{{ hiddenChipCount }} more</span>
            </div>
          }
        </div>
      }

      <!-- Placeholder when nothing is selected -->
      @if (selectedValues.length === 0) {
        <span class="multi-select__placeholder">{{ placeholder }}</span>
      }

      <!-- Clear all -->
      @if (selectedValues.length > 0) {
        <button class="multi-select__clear" type="button" (click)="clearAll($event)">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 4L4 12M4 4L12 12"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      }
    }

    <!-- Arrow -->
    <svg
      class="multi-select__arrow"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 10l5 5 5-5z" fill="#71717A" />
    </svg>
  </div>

  <!-- Dropdown panel -->
  @if (isOpen) {
    <div class="multi-select__dropdown">
      <!-- Search -->
      @if (showSearch) {
        <div class="multi-select__search">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
              stroke="#71717A"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14 14L11.1 11.1"
              stroke="#71717A"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <input
            type="text"
            [(ngModel)]="searchText"
            [ngModelOptions]="{ standalone: true }"
            [placeholder]="searchPlaceholder"
            class="multi-select__search-input"
            (click)="$event.stopPropagation()"
          />
        </div>
      }

      <!-- Options list -->
      <div class="multi-select__options">
        <!-- Select All row -->
        @if (selectAllLabel && !searchText.trim()) {
          <div
            class="multi-select__option"
            [class.multi-select__option--selected]="isAllSelected()"
            (click)="toggleSelectAll()"
          >
            <input
              type="checkbox"
              [checked]="isAllSelected()"
              class="multi-select__checkbox"
              (click)="$event.preventDefault()"
            />
            <span class="multi-select__label">{{ selectAllLabel }}</span>
          </div>
        }

        <!-- Individual options -->
        @for (option of getFilteredOptions(); track option.uuid) {
          <div
            class="multi-select__option"
            [class.multi-select__option--selected]="isSelected(option.uuid)"
            (click)="toggleOption(option.uuid)"
          >
            <input
              type="checkbox"
              [checked]="isSelected(option.uuid)"
              class="multi-select__checkbox"
              (click)="$event.preventDefault()"
            />
            <span class="multi-select__label">{{ option.name }}</span>
          </div>
        }

        <!-- Empty state -->
        @if (getFilteredOptions().length === 0) {
          <div class="multi-select__empty">{{ noResultsLabel }}</div>
        }
      </div>
    </div>
  }
</div>
